import { defineComponent, ref, computed } from 'vue';
import { Scrollbar as BaseScrollbar } from './BaseScrollbar';
export const scrollbarProps = {
    trigger: String,
    xScrollable: Boolean,
    onScroll: Function
};
const Scrollbar = defineComponent({
    name: 'PfScrollbar',
    props: scrollbarProps,
    setup() {
        const scrollbarInstRef = ref(null);
        const scrollContainer = computed(() => scrollbarInstRef.value?.containerRef);
        const scrollContent = computed(() => scrollbarInstRef.value?.contentRef);
        const exposedMethods = {
            scrollTo: (...args) => {
                scrollbarInstRef.value?.scrollTo(args[0], args[1]);
            },
            scrollBy: (...args) => {
                scrollbarInstRef.value?.scrollBy(args[0], args[1]);
            }
        };
        return {
            ...exposedMethods,
            scrollbarInstRef,
            scrollContainer,
            scrollContent
        };
    },
    render() {
        return (<BaseScrollbar ref="scrollbarInstRef" {...this.$props} v-slots={this.$slots}/>);
    }
});
export default Scrollbar;
